import { Toast } from "primereact/toast";
import { useEffect, useRef, lazy,Suspense } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootStateType } from "./storeRedux/store";
import { setToast } from "./storeRedux/slices/toast";
import { Navigate, Route, Routes } from "react-router-dom";
import { FrontLayout } from "./layout/frontend/layout";
import { routes } from "./routes";
// import { PageNotFound } from "./views/page-not-found";
// import { Home } from "views/home/home";
// import { Auth } from "views/auth/auth";
import { useLangContext } from "context/Lang";
import { setDirection } from "storeRedux/slices/configSlice";
import { LoadingPage } from "views/loading-page";
// import { Logout } from "views/auth/logout";
// import { ViewDashboard } from "views/dashboard/ViewDashboard";
// import { PrivacyPolicy } from "views/home/privacy-policy";

const Home = lazy(() => import("views/home/home").then(m => ({ default: m.Home })));
const PageNotFound = lazy(() => import("./views/page-not-found").then(m => ({ default: m.PageNotFound })));
const Auth = lazy(() => import("views/auth/auth").then(m => ({ default: m.Auth })));
const Logout = lazy(() => import("views/auth/logout").then(m => ({ default: m.Logout })));
const ViewDashboard = lazy(() => import("views/dashboard/ViewDashboard").then(m => ({ default: m.ViewDashboard })));
const PrivacyPolicy = lazy(() => import("views/home/privacy-policy").then(m => ({ default: m.PrivacyPolicy })));

export const App=()=>{


    const {config,toast}=useSelector((state:RootStateType)=>state) ;
    const {direction}= {...config}

    const {lang}= useLangContext();

    const dispatch  = useDispatch();
    
    const toastRef= useRef<Toast>(null);

    useEffect(()=>{
        if(toast.summary||toast.detail){
            toastRef.current?.show({
                detail:toast.detail,
                severity:toast.severity,
                summary:toast.summary,
                life:3000,
            } );
            dispatch(setToast({summary:undefined,detail:undefined}));
        }
    },[toast])


    useEffect(()=>{
        if(lang==="ar" && direction!=="rtl"){
            document.body.dir="rtl"

            dispatch(setDirection("rtl"))
        }else {
            document.body.dir="ltr"
            dispatch(setDirection("ltr"))
        }
    },[lang]);

    return <div >
        <Toast position={direction==="ltr"?"top-left":"top-right"} ref={toastRef} />
        <Suspense fallback={<LoadingPage/>}>
            <Routes>
                <Route element={<FrontLayout />}> 
                    
                    <Route path="*" element={<Navigate to={routes.pageNotFount} />}/>
                    <Route path={routes.pageNotFount} element={<PageNotFound/>} />
                    <Route path={routes.home} element={<Home/>} />
                    <Route path={routes.privacyPolicy} element={<PrivacyPolicy/>} />
                    <Route path={routes.logout} element={<Logout/>}  />
                    {/* {myRoutes.layout.map((route, index) => (<Route key={index} path={route.path} element={!viewLogo?route.element:<></>} />))} */}
                    
                    <Route path={routes.auth} element={<Auth/>} >
                        <Route path={routes.authProcess} element={<></>} />
                    </Route>
                </Route>

                <Route path={routes.dashboard} element={<ViewDashboard/>} >
                        <Route path={routes.dashboardRroute} element={<></>} />

                </Route>

                

                {/* <Route element={user?.role?<Outlet/>:<Navigate to={routes.home} state={{message:"no-access",color:"yellow"}}  />} >
                    <Route element={!viewLogo?<><ViewDashboard/>  </>:<Outlet/>}>
                        {myRoutes.dashboardLayout.map((route, index) => (<Route key={index} path={route.path} element={!viewLogo&&route.element} />))}
                    </Route>
                </Route> */}
            </Routes>
        </Suspense>
    </div>
};